<div class="container-fluid p-3">

    <span *ngIf="authService.isPortalManager() || authService.isPortalParaLegalTL()" >

        <ul class="nav nav-underline nav-fill">
          <li class="nav-item">
            <a class="nav-link" 
              [class.active]="activeTaskTab === 'management'"
              (click)="activeTaskTab = 'management'">
              Management Actions
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" 
              [class.active]="activeTaskTab === 'paralegal'"
              (click)="activeTaskTab = 'paralegal'">
              Paralegal Actions
            </a>
          </li>

          <li class="nav-item" *ngIf="authService.canSeeAdminActionList()">
            <a class="nav-link" 
              [class.active]="activeTaskTab === 'admin'"
              (click)="activeTaskTab = 'admin'">
              Admin Actions
            </a>
          </li>
        </ul>

        <div>
          <app-card>
            <app-task-list *ngIf="activeTaskTab === 'management'" 
                          userType="management" 
                          tasksFor="user" 
                          [showCompleted]="false">
            </app-task-list>

            <app-task-list *ngIf="activeTaskTab === 'paralegal'" 
                          userType="paralegal" 
                          tasksFor="user" 
                          [showCompleted]="false">
            </app-task-list>

            <app-task-list *ngIf="activeTaskTab === 'admin'" 
                          userType="admin" 
                          tasksFor="user" 
                          [showCompleted]="false">
            </app-task-list>
          </app-card>
        </div>
    </span>

    <span *ngIf="!authService.isPortalManager() && !authService.isPortalParaLegalTL()" >

        <div *ngIf="authService.canSeeParalegalActionList()">

          <app-card title="Actions">
              <div>
                <app-task-list userType="paralegal" tasksFor="user" [showCompleted]="false"></app-task-list>
              </div>
          </app-card>
        </div>

        <div *ngIf="authService.canSeeAdminActionList()">

        <app-card title="Actions" >
          <div>
            <app-task-list  userType="admin" tasksFor="user" [showCompleted]="false"></app-task-list>
          </div>
        </app-card>
        </div>

    </span>

    <div *ngIf="authService.canSeeUnallocatedCases()" class="mb-2">
      <app-card title="Unallocated Cases">
          <app-unallocated-case-list></app-unallocated-case-list>
      </app-card>
    </div>

    <ul class="nav nav-underline nav-fill">
      <li class="nav-item" *ngIf="authService.canSeeInstructedCases()">
        <a class="nav-link" 
          [class.active]="activeCasesTab === 'instructed'"
          (click)="activeCasesTab = 'instructed'"
          style="cursor: pointer;">
          Instructed Cases
        </a>
      </li>

      <li class="nav-item" *ngIf="authService.canSeeInstructedCases()">
        <a class="nav-link" 
          [class.active]="activeCasesTab === 'onhold'"
          (click)="activeCasesTab = 'onhold'"
          style="cursor: pointer;">
          On Hold Cases
        </a>
      </li>

      <li class="nav-item" *ngIf="authService.canSeeCompletedCases()">
        <a class="nav-link" 
          [class.active]="activeCasesTab === 'completed'"
          (click)="activeCasesTab = 'completed'"
          style="cursor: pointer;">
          Completed Cases
        </a>
      </li>

      <li class="nav-item" *ngIf="authService.canSeeCancelledCases()">
        <a class="nav-link" 
          [class.active]="activeCasesTab === 'cancelled'"
          (click)="activeCasesTab = 'cancelled'"
          style="cursor: pointer;">
          Cancelled Cases
        </a>
      </li>

      <li class="nav-item" *ngIf="authService.canSeeUninstructedCases()">
        <a class="nav-link" 
          [class.active]="activeCasesTab === 'uninstructed'"
          (click)="activeCasesTab = 'uninstructed'"
          style="cursor: pointer;">
          Uninstructed Cases
        </a>
      </li>
    </ul>

    <div>
      <app-card>
        <app-case-list *ngIf="activeCasesTab === 'instructed'"></app-case-list>
        <app-onhold-case-list *ngIf="activeCasesTab === 'onhold'"></app-onhold-case-list>
        <app-completed-case-list *ngIf="activeCasesTab === 'completed'"></app-completed-case-list>
        <app-cancelled-case-list *ngIf="activeCasesTab === 'cancelled'"></app-cancelled-case-list>
        <app-uninstructed-case-list *ngIf="activeCasesTab === 'uninstructed'"></app-uninstructed-case-list>
      </app-card>
    </div>

</div>


